module.exports = __webpack_public_path__ + "img/thumb-person.85e16207.png";